import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SelectionCompleteEvent } from '../../components/selectable.base';
import {
  SingleSelectedItemResult,
  SingleSelectionItem,
  SingleSelectionItemOption
} from '../../components/single-selection-list/single-selection-list.component';
import { SelectableItem } from '../../components/selectable-list/selectable-list.component';
// export interface SelectableStore extends SingleSelectionItem {
//   options: { value: number; label: string }[];
//   selectedValue: number;
//   allowCancel?: boolean;
// }

export interface StoreSelectionDialogData {
  singleSelectableStore?: SingleSelectionItem;
  multiSelectableStore?: SelectableItem[];
  allowCancel?: boolean;
}

export interface StoreSelectionDialogResult {
  storeName: string;
  dealerPerorgNo: number;
  sellerGroupId: number;
  storeId: number;
  success: boolean;
}

@Component({
  selector: 'iq-store-selection',
  templateUrl: 'store-selection.dialog.html',
  styleUrls: ['store-selection.dialog.scss']
})
export class StoreSelectionDialog {
  searchTerm: string;
  singleSelectableStore: SingleSelectionItem;
  multiSelectableStore: SelectableItem[];
  displayStores: SelectableItem[];
  allowCancel = false;

  constructor(
    public dialogRef: MatDialogRef<StoreSelectionDialog>,
    @Inject(MAT_DIALOG_DATA) public data: StoreSelectionDialogData
  ) {
    if (this.data.singleSelectableStore) {
      this.singleSelectableStore = { ...this.data.singleSelectableStore };
    } else {
      this.multiSelectableStore = [...this.data.multiSelectableStore];
      this.displayStores = [...this.multiSelectableStore];
    }
    this.allowCancel = this.data.allowCancel;
    this.dialogRef.disableClose = true;
  }

  onValidSelection(event: SelectionCompleteEvent<SingleSelectedItemResult>) {
    if (this.singleSelectableStore) {
      const storeId = Number(event.result.value);
      const store = this.singleSelectableStore.options.find(
        s => s.value === storeId
      );
      const storeName = store.label;
      const dealerPerorgNo = store.dealerPerorgNo;
      this.dialogRef.close({
        result: true,
        storeId,
        storeName,
        dealerPerorgNo
      });
    } else {
      const newSelection = this.multiSelectableStore.filter(s => s.selected);
      this.dialogRef.close({ result: true, newSelection });
    }
  }

  onExit() {
    this.dialogRef.close({ result: false });
  }

  onInput() {
    if (this.searchTerm.length > 2) {
      const searchTerm = this.searchTerm.toLowerCase();

      if (this.singleSelectableStore) {
        this.singleSelectableStore.options = this.filterSingleStores(
          this.data.singleSelectableStore.options,
          searchTerm
        );
        if (
          this.singleSelectableStore.options.length > 0 &&
          this.isStoreSelected(this.singleSelectableStore.options)
        ) {
          this.singleSelectableStore.selectedValue = this.singleSelectableStore.options[0].value;
        }
        this.singleSelectableStore = { ...this.singleSelectableStore };
      } else {
        this.multiSelectableStore.forEach(m => {
          const displayedStore = this.displayStores.find(d => d.id === m.id);
          if (displayedStore) {
            m.selected = displayedStore.selected;
          }
        });
        this.displayStores = this.filterMultiStores(
          this.data.multiSelectableStore,
          searchTerm
        );
        this.displayStores = [...this.displayStores];
      }
    } else {
      if (this.data.singleSelectableStore) {
        this.singleSelectableStore.options = [
          ...this.data.singleSelectableStore.options
        ];
      } else {
        this.displayStores = [...this.data.multiSelectableStore];
      }
    }
  }

  onChecked(e) {
    this.displayStores.find(s => s.id === e.id).selected = e.selected;
  }

  private filterSingleStores(
    stores: SingleSelectionItemOption[],
    searchTerm: string
  ): SingleSelectionItemOption[] {
    return stores.filter(s => s.label.toLowerCase().includes(searchTerm));
  }

  private filterMultiStores(
    stores: SelectableItem[],
    searchTerm: string
  ): SelectableItem[] {
    return stores.filter(s => s.name.toLowerCase().includes(searchTerm));
  }

  private isStoreSelected(stores: SingleSelectionItemOption[]): boolean {
    return (
      stores.findIndex(
        s => s.value === this.singleSelectableStore.selectedValue
      ) === -1
    );
  }
}
